export function createReturnJsFn(cb: (...args) => void) {
	const fnName = `__returnJsFn_${Date.now()}`;
	window.top[fnName] = (...args) => {
		delete window[fnName];
		cb?.(...args);
	};
	return `window.top['${fnName}']({0})`;
}
